<template>
  <subcribe-modal :modalActive="modalSub" @close="toggleModal()"></subcribe-modal>

  <section class="stdpilot-section" v-if="$route.name === 'studentPilot'">
    <base-info-bar>
      <router-link to="/admissions/student-pilot">{{ getMenuInfo.name}}</router-link>
      <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
        >
        <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
      <router-link :to="getSubMenuInfo.url" style="color: black;">{{ getSubMenuInfo.name }}</router-link>
    </base-info-bar>

    <StudentPilotContent :subMenu="getSubMenu"></StudentPilotContent>
  </section>

  <router-view></router-view>
</template>

<script>
import StudentPilotContent from '../../components/stdpilot-page/StudentPilotContent.vue'
export default {
  data () {
    return {
      modalSub: false
    }
  },
  components: {
    StudentPilotContent
  },
  computed: {
    getSubMenu () {
      if (this.$store.state.lang === 'vn') {
        return 15
      } else {
        return 34
      }
    },
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu'][4]
    },
    getSubMenuInfo () {
      return this.$store.getters['navbar/findSubMenus1'](this.getSubMenu)
    }
  },
  methods: {
    toggleModal () {
      this.modalSub = false
    }
  },
  mounted () {
    if (!sessionStorage.getItem('modalShown')) {
      this.modalSub = true // Open the modal only once per session
      sessionStorage.setItem('modalShown', 'true') // Set flag to prevent re-opening
    }
  }
}
</script>

<style scoped>
.stdpilot-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.stdpilot-section span{
  font-weight: 800;
}
</style>
